import { notification } from "@/lib/errorHandler";
import { createNote, fetchAllNotes } from "./serverInterationMethods";

export const notes = {
    actions: {
        async findAllNotes({ getters, commit }, { page, limit, sort }) {
            commit('setIsFindingAllNotes', true);
            try {
                const {data} = await fetchAllNotes(getters.token, page, limit, sort);
                if (getters.sort !== sort) {
                    commit('setSort', sort);
                    commit('setPage', 1);
                    commit('setFindResults', data);
                    return data.total;
                }
                if (getters.page !== page) {
                    const updatedData = {
                        notes: [...getters.notes ?? [], ...data.notes],
                        total: data.total,
                    }
                    commit('setPage', page);
                    commit('setSort', sort);
                    commit('setFindResults', updatedData);
                    return data.total;
                }
                commit('setFindResults', data);
                return data.total;
            } finally {
                commit('setIsFindingAllNotes', false);
            }
        },
        async createNote({ getters }, data) {
            try {
                await createNote(getters.token, data);
                notification.successNotification(this, 'Заметка успешно создана');
            } catch (e) {
                notification.errorNotification(this, 'Ошибка при создании заметки');
                console.log(e);
            }
        },
    },
    mutations: {
        setFindResults(state, { notes, total }) {
            state.notes = notes;
            state.totalNotes = total;
        },
        setPage(state, page) {
            state.page = page;
        },
        setSort(state, sort) {
            state.sort = sort;
        },
        setIsFindingAllNotes(state, value) {
            state.isFindingAllNote = value;
        },
        resetNotes(state) {
            state.notes = [];
            state.totalNotes = 0;
            state.page = 1;
            state.sort = 'desc';
            state.isFindingAllNote = false;
        }
    },
    state: {
        notes: [],
        totalNotes: 0,
        page: 1,
        sort: 'desc',
        isFindingAllNote: false,
    },
    getters: {
        notes: state => state.notes,
        totalNotes: state => state.totalNotes,
        sort: state => state.sort,
        page: state => state.page,
        isFindingAllNote: state => state.isFindingAllNote,
    }
}